import axios from '../util/CustomAxios';
export const SET_COMPANY = 'SET_COMPANY';

export function setCompany(company) {
  return {
    type: SET_COMPANY,
    company: company,
  };
}
